<template>
  <div
    id="m-wallet-identity-no-timeout"
    class="manifold"
  />
</template>
